/// <reference path='../../../../../common/types/window-config.d.ts' />
import * as React from 'react';
import { useState, useEffect } from 'react';
import { spConfig } from '@enginuity-common/types/window-config';

interface IConfigLoaderProps {
  ready: (config?: spConfig) => JSX.Element;
}

// eslint-disable-next-line react/prop-types
export default function ConfigLoader({ ready }: IConfigLoaderProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [config, setConfig] = useState<spConfig>();

  function loadConfig() {
    return fetch('/configuration.json')
      .then(result => {
        return result.json();
      })
      .then(newconfig => {
        return newconfig;
      });
  }

  useEffect(() => {
    loadConfig().then(config => {
      window.spConfig = config;
      setConfig(config);
      setIsLoaded(true);
    });
  }, []);

  return <>{isLoaded ? ready(config) : <></>}</>
}
